<template>
	<div>
		<navTitle><div class="pageTitle">资讯详情</div></navTitle>
		<template v-if="detail.is_link == 0">
			<div class="news">
				<div class="title">{{detail.title}}</div>
				<div class="tips flex flex-align-center flex-jus-center">
					<div class="text1">{{detail.author}}</div>
					<div class="text2">{{detail.create_time | formatDate_noS}}</div>
				</div>
				
				<div class="content" v-html="detail.content"></div>
			</div>
		</template>
		<div v-else class="linkBox">
			<a class="link_a" :href="detail.content">
				{{detail.title}}
			</a>
			<!-- <iframe class="iframe" :src="detail.content" frameborder="0"></iframe> -->
		</div>
		
		<div class="newsBottom flex flex-align-center flex-jus-between">
			<div class="flex flex-1 flex-align-center">
				<img @click="doLike" v-if="detail.is_likes == 0" src="@/static/images/index/good.png" class="icon">
				<img @click="doLike" v-if="detail.is_likes == 1" src="@/static/images/index/good_yes.png" class="icon">
				<div class="goodNumber">{{detail.likes_num}}</div>
			</div>
			<div class="flex-1 flex flex-align-center flex-jus-center">
				<img @click="save" v-if="detail.is_collection == 0" src="@/static/images/index/love.png" class="icon">
				<img @click="save" v-if="detail.is_collection == 1" src="@/static/images/index/love_yes.png" class="icon">
			</div>
			<div @click="shareH5" class="flex-1 flex flex-align-center flex-jus-end">
				<img src="@/static/images/index/share.png" class="icon">
			</div>
		</div>
		
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		watch: {
		},
		data() {
			return{
				detail: {}
			}
		},
		created() {
			this.getData()
		},
		mounted() {

		},
		methods: {
			getData() {
				this.$get('api/actile/getNewsDetails', {
					id: this.$route.query.id
				}).then(res => {
					console.log(res)
					this.detail = res.data
					this.share()
				})
			},
			doLike() {
				this.$post('api/actile/doLikes', {
					type: '1',
					article_id: this.$route.query.id
				}).then(() => {
					this.getData()
				})
			},
			save() {
				this.$post('api/actile/doCollection', {
					type: '1',
					article_id: this.$route.query.id
				}).then(() => {
					this.getData()
				})
			},
			share() {
				this.$wx.updateAppMessageShareData({
					title: this.detail.title,
					desc: '福建省民族管弦乐学会 资讯',
					link: location.href,
					imgUrl: this.detail.pic
				})
				this.$wx.updateTimelineShareData({
					title: this.detail.title,
					link: location.href,
					imgUrl: this.detail.pic
				})
			},
			shareH5() {
				this.$toast('请从右上角分享')
			}
		}
	}
</script>
<style scoped>
	.content >>> img {
		max-width: 100%;
		height: auto;
	}
</style>
<style scoped lang="stylus">
.linkBox {
	height calc(100vh - 98px);
	padding 30px;
	// padding-bottom 98px;
	.link_a {
		font-size 32px
	}
}
.iframe {
	width 100%;
	height 100%;
}
.news
	padding 24px 30px 98px
	background-color #FFFFFF
	.title
		width 100%
		text-align center
		font-size: 30px;
		font-weight: bold;
		color: #000000;
	.tips
		margin-top 26px
		width 100%
		font-size: 22px;
		color: #979797;
		.text1
			width max-content
		.text2
			width max-content
			margin-left: 40px;
	.content
		margin-top 40px
		word-break break-all
.newsBottom
	position fixed
	bottom 0
	left 0
	width 100%
	height: 98px;
	background: #FFFFFF;
	box-shadow: 0px -6px 24px rgba(0, 0, 0, 0.05);
	padding 28px 30px
	font-size: 28px;
	color: #000000;
	.icon
		width 44px
		height 44px
	.goodNumber
		margin-top 4px
		margin-left 10px
</style>
